import {styled} from "@mui/material";

export const ManagementPagesContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0 2.5rem',
}));
